import { Button, styled } from "@mui/material";
import { Link } from "react-scroll";

const MainContainer = styled("div")({
  width: "100%",
  height: "90vh",
  color: "black",
  backgroundColor: "#f8f8f8",
  boxSizing: "border-box",
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "4px",
  backgroundSize: "initial",
  backgroundImage:
    'linear-gradient(rgba(255,255,255,0.8), rgba(255,255,255, .97)), url("images/grid.jpg")',
  "@media (max-width: 650px)": {
    display: "none",
  },
});

const InfoContainer = styled("div")({
  backgroundColor: "#fff",
  height: "400px",
  width: "360px",
  margin: "0 5rem 0 2rem",
  textAlign: "left",
});

const InfoHeader = styled("h1")({
  fontFamily: "Open Sans",
  fontStyle: "normal",
  fontWeight: 300,
  fontSize: "2em",
  lineHeight: "60px",
});

const InfoDescription = styled("p")({
  fontFamily: "Open Sans",
  fontStyle: "normal",
  fontWeight: "normal",
  fontSize: "14px",
  lineHeight: "1.5em",
  color: "#868686",
});

const StyledGif = styled("img")({
  width: "50vw",
  maxWidth: "500px",
  margin: "0 1rem 0 0",
  borderRadius: "4px",
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
});

const StyledButton = styled(Button)({
  backgroundColor: "#000000",
  color: "#fff",
  textTransform: "unset",
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  padding: "8px 16px",
  fontSize: "14px",
  lineHeight: "19px",
  ":hover": {
    backgroundColor: "#2196f3",
  },
});

const WorkflowBanner = () => (
  <MainContainer>
    <InfoContainer>
      <InfoHeader>{`The best workflows,\n all in one place`}</InfoHeader>
      <InfoDescription>
        Browse the Workflow86 templates library for best practice workflows that
        you can download, run and cutomize with just one click. All built in
        Worflow86 - the fastest way to document, automate and scale your
        internal business processes.
      </InfoDescription>
      <Link to="featuredTemplate" smooth offset={-80}>
        <StyledButton>👇 BROWSE TEMPLATES</StyledButton>
      </Link>
    </InfoContainer>
    <StyledGif src="images/newb.gif" />
  </MainContainer>
);

export default WorkflowBanner;
